// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__2u1lh","tag__title":"styles_tag__title__122PR"};